import { useRoutes } from "react-router-dom";
import routes from "./config";
// import { useProfile } from "../hooks/useProfile";

export function AppRoutes() {
  // useProfile();
  
  const element = useRoutes(routes);
  
  return element;
}